module.exports = __webpack_public_path__ + "static/media/policyDetails.6cb077ef.svg";